module.exports = __webpack_public_path__ + "static/media/tab_health.b3351cf1.svg";